export function normalizeTabKey(value) {
  if (value == null) return "";
  const s = typeof value === "string" ? value : String(value);
  return s.trim().toLowerCase();
}

/**
 * Normalizes test.pestanas (string or string[]) to comparable lowercase trimmed labels.
 */
export function normalizeTestPestanasForTab(test) {
  if (!test || typeof test !== "object") {
    return [];
  }
  const raw = test.pestanas;
  if (raw == null) {
    return [];
  }
  if (typeof raw === "string") {
    const k = normalizeTabKey(raw);
    return k ? [k] : [];
  }
  if (!Array.isArray(raw)) {
    return [];
  }
  return raw
    .filter((p) => typeof p === "string")
    .map((p) => normalizeTabKey(p))
    .filter((k) => k.length > 0);
}

/**
 * Whether the test is associated with the active course tab (case-insensitive, trimmed).
 */
export function testMatchesTab(test, activeTab) {
  if (activeTab == null) {
    return false;
  }
  const tabKey = normalizeTabKey(String(activeTab));
  if (tabKey === "") {
    return false;
  }
  const labels = normalizeTestPestanasForTab(test);
  return labels.some((label) => label === tabKey);
}
